import { initializeApp } from "firebase/app";
import { supabase } from "./supabase";

export async function getPolicy() {
  try {
    const { data, error } = await supabase.from("company_policy").select("*").eq("id", 1).single();
    if (error || !data) return null;
    return data;
  } catch (e) { return null; }
}

export async function savePolicy(fields) {
  try {
    const { error } = await supabase.from("company_policy").update(fields).eq("id", 1);
    return !error;
  } catch (e) { return false; }
}


export function getNth(year, month, weekday, n) {
  let count = 0;
  for (let d = 1; d <= 31; d++) {
    const dt = new Date(year, month - 1, d);
    if (dt.getMonth() !== month - 1) break;
    if (dt.getDay() === weekday) { count++; if (count === n) return dt; }
  }
}
export function getLast(year, month, weekday) {
  for (let d = 31; d >= 1; d--) {
    const dt = new Date(year, month - 1, d);
    if (dt.getMonth() !== month - 1) continue;
    if (dt.getDay() === weekday) return dt;
  }
}
export function fmtDate(dt) { return dt ? dt.toISOString().slice(0, 10) : ""; }
// YYYY-MM-DD → MM/DD/YYYY (표시용)
export function fmtDateDisplay(str) {
  if(!str) return "";
  const parts = str.split("-");
  if(parts.length===3) return `${parts[1]}/${parts[2]}/${parts[0]}`;
  return str;
}
// MM/DD/YYYY → YYYY-MM-DD (저장용)
export function parseDisplayDate(str) {
  if(!str) return "";
  const parts = str.split("/");
  if(parts.length===3) return `${parts[2]}-${parts[0].padStart(2,"0")}-${parts[1].padStart(2,"0")}`;
  return str;
}

export function getHolidays(year) {
  const raw = [
    [new Date(year,0,1),"New Year's Day"],
    [getNth(year,1,1,3),"Martin Luther King Jr. Day"],
    [getNth(year,2,1,3),"Presidents' Day"],
    [getLast(year,5,1),"Memorial Day"],
    [new Date(year,5,19),"Juneteenth"],
    [new Date(year,6,4),"Independence Day"],
    [getNth(year,9,1,1),"Labor Day"],
    [getNth(year,10,1,2),"Columbus Day"],
    [new Date(year,10,11),"Veterans Day"],
    [getNth(year,11,4,4),"Thanksgiving Day"],
    [new Date(year,11,25),"Christmas Day"],
  ];
  const r = {};
  raw.forEach(([dt,name]) => {
    if (!dt) return;
    const day = dt.getDay(); let obs = new Date(dt);
    if (day===6) obs.setDate(dt.getDate()-1);
    else if (day===0) obs.setDate(dt.getDate()+1);
    r[fmtDate(obs)] = (day===6||day===0) ? name+" (observed)" : name;
  });
  return r;
}

export const HOLIDAY_ES = {
  "New Year's Day":"Año Nuevo","Martin Luther King Jr. Day":"Día de Martin Luther King Jr.","Presidents' Day":"Día de los Presidentes",
  "Memorial Day":"Día de los Caídos","Juneteenth":"Juneteenth","Independence Day":"Día de la Independencia","Labor Day":"Día del Trabajo",
  "Columbus Day":"Día de la Raza (Columbus Day)","Veterans Day":"Día de los Veteranos","Thanksgiving Day":"Día de Acción de Gracias","Christmas Day":"Navidad",
};
export function holidayName(name, lang) {
  if (lang !== "es" || !name) return name;
  const obs = / \(observed\)$/.test(name);
  const base = obs ? name.replace(/ \(observed\)$/, "") : name;
  const es = HOLIDAY_ES[base] || base;
  return obs ? es + " (observado)" : es;
}

export function getBaseVacDays(joinDate, tiers) {
  const d = tiers || [2,4,6,8,10,12];
  if (!joinDate) return d[0];
  const yrs = (new Date()-new Date(joinDate))/(1000*60*60*24*365.25);
  if (yrs>=10) return d[5]; if (yrs>=7) return d[4]; if (yrs>=5) return d[3];
  if (yrs>=3) return d[2];   if (yrs>=1) return d[1];  return d[0];
}
export function getAllocatedVac(emp, tiers) {
  const base = getBaseVacDays(emp.join_date, tiers);
  return base + (parseInt(emp.vac_adjust)||0);
}

export const POLICY = {
  workHours:{start:"8:00 AM",end:"5:00 PM",days:"Mon – Fri"},
  workHoursKo:{start:"오전 8:00",end:"오후 5:00",days:"월 – 금"},
  breaks:[
    {label:"Lunch Break",    labelKo:"점심 휴식",  time:"11:30 AM – 12:15 PM", dur:"45 min", durKo:"45분"},
    {label:"Afternoon Break",labelKo:"오후 휴식",  time:"3:00 – 3:15 PM",      dur:"15 min", durKo:"15분"},
  ],
  vacation:[
    {range:"0–1 yr",days:2},{range:"1–3 yrs",days:4},
    {range:"3–5 yrs",days:6},{range:"5–7 yrs",days:8},
    {range:"7–9 yrs",days:10},{range:"10+ yrs",days:12},
  ],
  sickDays:5, sickHours:40,
  vacRules:[
    "Must be requested at least 1 month in advance.",
    "Max 7 consecutive days unless approved by executive management.",
    "Fairness among employees must be considered.",
    "Unused paid sick leave expires at year-end (no payout).",
  ],
};

export const KO = {
  appName:"SPRINGBLINDS TEAM", appSub:"직원 근태 · 성과평가 통합 관리",
  login:"로그인", id:"아이디", pw:"비밀번호", loginErr:"아이디 또는 비밀번호가 올바르지 않습니다.",
  nav:{ dash:"대시보드",leave:"근태",eval:"성과평가",emp:"직원 관리",cal:"캘린더",safety:"안전교육",sep:"인사 기록",policy:"회사 정책",logout:"로그아웃",lunch:"점심식사" },
  dash:{
    todayAbsent:"오늘 결근/휴가", monthLeave:"이번 달 근태", thisWeekLeave:"이번 주 휴가", yearEval:"올해 성과평가", safetyQ:"분기 안전교육",
    empLeave:"직원 근태 현황", recent:"최근 근태 기록", noRecord:"기록 없음", collapse:"접기", expand:"펼치기",
    onDuty:"근무 중", offHours:"근무 외", remainTitle:"직원별 남은 휴가",
    remainVac:"연차", remainSick:"병가",
  },
  leave:{
    title:"근태 · 특이사항 관리", sub:"연차, 병가, 특이사항을 기록하고 조회합니다.",
    listTab:"기록 조회", addTab:"+ 새 기록", addTabEmp:"+ 신청",
    addTitle:"근태 기록 추가", editTitle:"근태 기록 수정",
    empSel:"직원 선택 *", typeSel:"유형 *", dateLbl:"날짜 *", daysLbl:"일수",
    reasonLbl:"사유", noteLbl:"특이사항",
    placeholder:"선택해주세요", reasonPh:"예: 개인 사정, 감기, 병원 방문...", notePh:"추가 메모",
    save:"저장", cancel:"취소", del:"삭제", edit:"수정", confirmDel:"삭제하시겠습니까?",
    allEmp:"전체 직원", allType:"전체 유형",
    colEmp:"직원", colType:"유형", colDate:"날짜", colDays:"일수", colReason:"사유", colNote:"특이사항",
    types:["연차","병가","특이사항"],
    remainVac:"연차", remainSick:"병가",
    vacInfo:"유급 연차: 최소 1개월 전 신청. 최대 연속 7일.",
    sickInfo:"유급 병가: 연 5일. 3일 이상 연속 시 의료 서류 필요.",
    holiday:"US 연방 공휴일", loading:"불러오는 중...",
    importTab:"NGteco 가져오기",
    importTitle:"Timecard 가져오기",
    importSub:"Cloud에서 다운로드한 Excel 파일을 업로드하면 출퇴근 기록이 자동으로 등록됩니다.",
    importBtn:"Excel 파일 선택 (.xlsx)",
    importPreview:"미리보기",
    importConfirm:"가져오기 실행",
    importSuccess:"건 가져오기 완료!",
    importSkip:"건 중복 스킵",
    importError:"파일 읽기 오류. Timecard Report 형식인지 확인해주세요",
    importCols:"Name, Date, Timesheet, Clock In, Clock Out, Clock Time(h), Total Break Time(h), Total Work Time(h), Total Time(h), Total Overtime Time(h), Abnormal Situation 컬럼이 필요합니다.",
    noClockOut:"퇴근 미기록",
    colName:"직원", colDate:"날짜", colTimesheet:"근무유형",
    colIn:"출근", colOut:"퇴근",
    colClock:"근무시간(h)", colBreak:"휴식시간(h)",
    colWork:"총 근무(h)", colTotal:"총 시간(h)",
    colOT:"초과근무(h)", colAbnormal:"예외 상황",
    importDupKey:"※ 동일 날짜+이름 기록은 스킵됩니다.",
    attendTab:"출퇴근 기록", leaveTab:"휴가 · 특이사항",
    late:"지각", earlyOut:"조퇴", normal:"정상", notClockedOut:"퇴근 미기록",
    lateStd:"지각 기준", filterAll:"전체", filterLate:"지각만", filterAbnormal:"이상 있음",
    noData:"데이터 없음",
    totalRecords:"전체 기록", statusHdr:"상태", abnormalHdr:"예외 상황",
  },
  eval:{
    title:"성과평가 관리", sub:"성과평가, 신입평가, 근거 기록을 관리합니다.",
    tabPerf:"정기 성과평가", tabNew:"신입 사원 평가", tabNote:"근거 기록",
    listTab:"평가 조회", addTab:"+ 새 평가",
    addTitle:"성과평가 작성", editTitle:"성과평가 수정",
    empSel:"직원 선택 *", periodLbl:"평가 기간 *", evalDateLbl:"평가일 *",
    evaluatorLbl:"평가자", evaluator2Lbl:"평가자 2",
    goalsLbl:"성과 목표", outstandingLbl:"우수 성과 영역", improveLbl:"개선 필요 영역",
    readinessLbl:"확장 업무 준비도", nextGoalsLbl:"내년 성과 목표", nextDevLbl:"내년 개발 목표",
    empCommentLbl:"직원 의견",
    scoreTitle:"역량 평가 (5=탁월 | 4=우수 | 3=보통 | 2=미흡 | 1=불만족 | N/A)",
    avgLbl:"종합 평균",
    commentLbl:"종합 평가 코멘트", goalLbl:"다음 기간 목표",
    commentPh:"이번 기간 전반적인 평가 내용", goalPh:"다음 평가 기간의 목표나 개선점",
    noEval:"평가 기록이 없습니다", placeholder:"선택해주세요",
    save:"저장", cancel:"취소", del:"삭제", edit:"수정", confirmDel:"삭제하시겠습니까?",
    allEmp:"전체 직원", downloadPdf:"PDF 다운로드",
    uploadSigned:"서명 업로드", viewSigned:"서명 보기",
    statusSigned:"서명 완료", statusPending:"서명 대기",
    items:[
      {key:"c1",label:"업무 성과 및 숙련도"},
      {key:"c2",label:"직무 수행 역량"},
      {key:"c3",label:"업무 계획 및 우선순위"},
      {key:"c4",label:"책임감 및 기한 준수"},
      {key:"c5",label:"업무 효율성"},
      {key:"c6",label:"소통 능력"},
      {key:"c7",label:"독립적 업무 수행"},
      {key:"c8",label:"팀워크"},
      {key:"c9",label:"추가 책임 수용"},
      {key:"c10",label:"신뢰성 (출근·시간엄수)"},
      {key:"c11",label:"문제 해결 및 판단력"},
    ],
    commentCol:"평가", goalCol:"목표",
    newEmpTitle:"신입 사원 평가", newEmpSub:"신입 직원의 적응 및 업무 능력을 평가합니다",
    newListTab:"평가 조회", newAddTab:"+ 새 평가",
    newEmpNameLbl:"신입 직원 이름 *", newEmpNumLbl:"직원 번호", newDeptLbl:"부서", newHireLbl:"입사일",
    newEval1Lbl:"평가자 1 *", newEval2Lbl:"평가자 2", newEvalDateLbl:"평가일",
    newCriteria:["최대 역량","업무 품질","업무 일관성","소통 능력","독립적 업무","적극성/주도성","팀워크","생산성","창의성","정직성","성실성","동료 관계","고객 서비스","기술 역량","신뢰성","시간 준수","출근"],
    newRatings:["5","4","3","2","1","N/A"],
    newStrengthLbl:"핵심 강점", newImproveLbl:"개선 필요 영역",
    newPrevGoalLbl:"이전 목표 달성도", newNextGoalLbl:"다음 평가 목표",
    newEmpCommentLbl:"직원 의견", newEval1CommentLbl:"평가자 1 의견", newEval2CommentLbl:"평가자 2 의견",
    noNewEval:"신입 평가 기록이 없습니다",
    noteTitle:"근거 기록", noteSub:"성과평가 근거가 되는 사례를 수시로 기록합니다",
    noteListTab:"기록 조회", noteAddTab:"+ 새 기록",
    noteEmpLbl:"직원 선택 *", noteDateLbl:"날짜 *", noteCatLbl:"분류",
    noteContentLbl:"내용 *", noteContentPh:"구체적인 사례, 행동, 결과를 기록하세요",
    noteCats:["우수 성과","개선 필요","특이사항","고객 피드백","팀 기여"],
    noNote:"근거 기록이 없습니다",
  },
  emp:{
    title:"직원 관리", sub:"직원 목록을 등록하고 관리합니다.",
    addTitle:"직원 추가", editTitle:"직원 정보 수정", listTitle:"직원 목록",
    nameLbl:"이름 *", deptLbl:"부서", posLbl:"직책", joinLbl:"입사일", adjLbl:"연차 조정 (±일)",
    namePh:"홍길동", deptPh:"개발팀", posPh:"팀장",
    colName:"이름", colDept:"부서", colPos:"직책", colJoin:"입사일", colVac:"부여 연차",
    save:"저장", cancel:"취소", del:"삭제", edit:"수정", confirmDel:"삭제하시겠습니까?",
    noEmp:"등록된 직원이 없습니다",
  },
  cal:{ title:"근태 캘린더", holiday:"US 연방 공휴일" },
  safety:{
    title:"분기별 안전교육 관리", sub:"분기별 안전교육 확인서를 작성하고 서명 파일을 업로드합니다.",
    listTab:"기록 조회", addTab:"+ 새 기록",
    addTitle:"안전교육 기록 추가", editTitle:"안전교육 기록 수정",
    quarterLbl:"교육 분기 *", yearLbl:"교육 연도 *", dateLbl:"교육 날짜",
    managerLbl:"담당 매니저", notesLbl:"비고",
    empSelLbl:"서명 인원 선택 *", empSelSub:"PDF에 포함할 직원을 선택하세요",
    save:"저장", cancel:"취소", del:"삭제", edit:"수정", confirmDel:"삭제하시겠습니까?",
    downloadPdf:"PDF 다운로드", uploadSigned:"서명 업로드", viewSigned:"서명 보기",
    noRecord:"기록 없음", loading:"불러오는 중...",
    quarters:["Q1 (1월~3월)","Q2 (4월~6월)","Q3 (7월~9월)","Q4 (10월~12월)"],
    statusSigned:"서명 완료", statusPending:"서명 대기",
    selectAll:"전체 선택", deselectAll:"전체 해제",
    placeholder:"선택해주세요",
  },
  sep:{
    title:"HR Records", sub:"해고 및 퇴사 문서를 작성하고 관리합니다.",
    tabTerm:"해고 기록", tabResign:"퇴사 기록",
    listTab:"기록 조회", addTab:"+ 새 기록",
    empLbl:"직원 이름 *", posLbl:"직책", deptLbl:"부서", dateLbl:"날짜 *",
    employerLbl:"고용주", conductedLbl:"진행자",
    witnessLbl:"입회인", empResponseLbl:"직원 반응",
    termTitle:"해고 기록", termSub:"해고 문서를 작성하고 PDF로 저장합니다",
    reasonLbl:"해고 사유 (요약)", detailLbl:"상세 내용 (A. B. C. 형식으로 작성)",
    impactLbl:"누적 영향", warningLbl:"구두 경고 여부", writtenLbl:"서면 경고 여부",
    legalLbl:"법적 준수 사항",
    preparedLbl:"작성자 이름", preparedTitleLbl:"직책", reviewedLbl:"검토자 이름", reviewedTitleLbl:"직책",
    resignTitle:"퇴사 기록", resignSub:"퇴사 문서를 작성하고 PDF로 저장합니다",
    resignReasonLbl:"퇴사 사유", noticeDateLbl:"퇴사 통보일", lastDayLbl:"마지막 근무일",
    severanceLbl:"퇴직금 지급액 ($)", severanceDetailLbl:"퇴직금 세부 내용",
    accrualLbl:"미사용 휴가 지급", benefitsLbl:"복리후생 종료일",
    exitInterviewLbl:"퇴사 면담 실시 여부", equipmentLbl:"장비 반납 여부", accessLbl:"접근 권한 해제 여부",
    save:"저장", cancel:"취소", del:"삭제", edit:"수정", confirmDel:"삭제하시겠습니까?",
    downloadPdf:"PDF 다운로드", uploadSigned:"서명 업로드", viewSigned:"서명 보기",
    noRecord:"기록 없음", loading:"불러오는 중...",
    statusSigned:"서명 완료", statusPending:"서명 대기",
  },
  policy:{
    title:"회사 정책", sub:"근무시간, 휴가, 병가 규정을 확인합니다.",
    workTitle:"근무 시간", breakTitle:"휴식 시간", vacTitle:"유급 휴가 (근속연수별)",
    sickTitle:"유급 병가", rulesTitle:"휴가 규정", holidayTitle:"공휴일 정책",
    workDays:"근무일", hours:"근무시간", annualLimit:"연간 한도", carryOver:"이월",
    noPayOut:"미사용 소멸", docReq:"서류 필요",
    carryVal:"가능 (최대 40시간)", noPayVal:"없음", docVal:"3일 이상 연속",
    holidayNote:"회사는 모든 US 연방 공휴일을 준수합니다. 단, 업무 상황에 따라 출근이 요구될 수 있습니다.\n• 휴무 시: 유급 휴일\n• 출근 요청: 최소 2일 전 사전 고지",
    rules:["최소 1개월 전 신청 필요.","최대 연속 7일 (경영진 승인 시 예외).","직원 간 형평성 고려.","긴급 상황 시 사전 통보 기간이 단축될 수 있습니다.","미사용 유급 휴가는 연도 말 소멸되며 지급되지 않습니다."],
    dayUnit:"일", hrUnit:"시간",
    conductTitle:"근무 수칙",
    conductSub:"휴대폰, 음악/오디오, 호칭 정책",
    phoneTitle:"휴대폰 정책",
    phoneRules:[
      "근무 시간 중 개인 휴대폰은 지정된 사물함에 보관해야 합니다.",
      "휴대폰은 작업장 내에서 사용할 수 없으며, 긴급 통화는 지정된 휴식 시간 중 작업장 외부에서만 가능합니다.",
      "가족 긴급 상황 등 부득이한 경우 관리자의 허가를 받아 사용할 수 있으며, 반드시 작업장 외부에서 처리해야 합니다.",
      "스마트워치 등 통화·메시지 수신이 가능한 웨어러블 기기도 동일한 제한이 적용됩니다.",
      "업무용 휴대폰 또는 업무 목적으로 허가된 개인 휴대폰 사용자는 본 정책에서 제외됩니다.",
    ],
    musicTitle:"음악/오디오 정책",
    musicRules:[
      "작업장 내에서 유선 또는 무선 이어폰·헤드폰 착용은 엄격히 금지됩니다.",
      "공용 스피커를 통한 저음량 음악 재생은 다른 직원에게 방해가 되지 않는 경우에 한해 허용됩니다.",
      "볼륨은 주변 작업장 소음 수준을 초과하지 않아야 하며, 동료가 볼륨을 낮춰달라고 요청할 경우 즉시 따라야 합니다.",
      "음악 선택은 전문적인 업무 환경에 적합해야 하며, 불쾌하거나 명시적이거나 방해가 되는 내용은 허용되지 않습니다.",
      "고객 응대 또는 집중 업무가 필요한 공간에서는 관리자 재량으로 음악이 금지될 수 있습니다.",
    ],
    addressTitle:"호칭 규정",
    addressRules:[
      "모든 직원은 동료를 지칭하거나 대화할 때 '님' 또는 '씨'와 같은 존댓말 호칭을 사용해야 합니다.",
      "직위나 연차에 관계없이 모든 직원에게 적용되며, 상호 존중과 전문적인 업무 환경을 조성하기 위한 정책입니다.",
    ],
  },
  calToday:"오늘",
  months:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],
  weekdays:["일","월","화","수","목","금","토"],
  today:(d)=>d.toLocaleDateString("ko-KR",{year:"numeric",month:"long",day:"numeric",weekday:"long"}),
  langBtn:"English", darkBtn:"다크모드", lightBtn:"라이트모드", dayUnit:"일",
};

export const EN = {
  appName:"SPRINGBLINDS TEAM", appSub:"Employee Attendance & Performance Management",
  login:"Login", id:"Username", pw:"Password", loginErr:"Invalid username or password.",
  nav:{ dash:"Dashboard",leave:"Attendance",eval:"Performance",emp:"Employees",cal:"Calendar",safety:"Safety Training",sep:"HR Records",policy:"Policy",logout:"Logout",lunch:"Lunch" },
  dash:{
    todayAbsent:"Today Absent", monthLeave:"This Month", thisWeekLeave:"This Week Off", yearEval:"This Year Evals", safetyQ:"Safety Training",
    empLeave:"Employee Leave Status", recent:"Recent Records", noRecord:"No records found", collapse:"Collapse", expand:"Expand",
    onDuty:"On Duty", offHours:"Off Hours", remainTitle:"Remaining Leave by Employee",
    remainVac:"Annual Leave", remainSick:"Sick Leave",
  },
  leave:{
    title:"Attendance Management", sub:"Record and view leave, sick days, half-days, and notes.",
    listTab:"View Records", addTab:"+ New Record", addTabEmp:"+ Request",
    addTitle:"Add Record", editTitle:"Edit Record",
    empSel:"Employee *", typeSel:"Type *", dateLbl:"Date *", daysLbl:"Days",
    reasonLbl:"Reason", noteLbl:"Notes",
    placeholder:"Please select", reasonPh:"e.g. Personal, Cold, Doctor...", notePh:"Additional notes",
    save:"Save", cancel:"Cancel", del:"Delete", edit:"Edit", confirmDel:"Are you sure?",
    allEmp:"All Employees", allType:"All Types",
    colEmp:"Employee", colType:"Type", colDate:"Date", colDays:"Days", colReason:"Reason", colNote:"Notes",
    types:["연차","병가","특이사항"],
    remainVac:"Annual Leave", remainSick:"Sick Leave",
    vacInfo:"Paid Vacation: Request 1 month in advance. Max 7 consecutive days.",
    sickInfo:"Paid Sick Leave: 5 days/year. Documentation required for 3+ consecutive days.",
    holiday:"US Federal Holiday", loading:"Loading...",
    importTab:"Import NGteco",
    importTitle:"Import Timecard",
    importSub:"Upload the Excel file exported from Cloud to automatically import attendance records.",
    importBtn:"Select Excel File (.xlsx)",
    importPreview:"Preview",
    importConfirm:"Run Import",
    importSuccess:"records imported!",
    importSkip:"duplicates skipped",
    importError:"File read error. Please check if it is Timecard Report format",
    importCols:"Required: Name, Date, Timesheet, Clock In, Clock Out, Clock Time(h), Total Break Time(h), Total Work Time(h), Total Time(h), Total Overtime Time(h), Abnormal Situation",
    noClockOut:"Not clocked out",
    colName:"Employee", colDate:"Date", colTimesheet:"Schedule",
    colIn:"Clock In", colOut:"Clock Out",
    colClock:"Clock(h)", colBreak:"Break(h)",
    colWork:"Work(h)", colTotal:"Total(h)",
    colOT:"OT(h)", colAbnormal:"Exception",
    importDupKey:"Same name+date records will be skipped",
    attendTab:"Attendance", leaveTab:"Leave · Notes",
    late:"Late", earlyOut:"Early Out", normal:"Normal", notClockedOut:"Not clocked out",
    lateStd:"Late standard", filterAll:"All", filterLate:"Late only", filterAbnormal:"Exception",
    noData:"No data",
    totalRecords:"Total Records", statusHdr:"Status", abnormalHdr:"Exception",
  },
  eval:{
    title:"Performance Management", sub:"Manage evaluations, new employee assessments, and notes.",
    tabPerf:"Performance Eval", tabNew:"New Employee Eval", tabNote:"Performance Notes",
    listTab:"View Evals", addTab:"+ New Eval",
    addTitle:"Write Evaluation", editTitle:"Edit Evaluation",
    empSel:"Employee *", periodLbl:"Period *", evalDateLbl:"Eval Date *",
    evaluatorLbl:"Evaluator", evaluator2Lbl:"Evaluator 2",
    goalsLbl:"Performance Goals", outstandingLbl:"Areas of Outstanding Performance", improveLbl:"Areas Requiring Improvement",
    readinessLbl:"Readiness for Expanded Responsibilities", nextGoalsLbl:"Next Year Performance Goals", nextDevLbl:"Next Year Development Goals",
    empCommentLbl:"Employee Comments",
    scoreTitle:"Performance Competencies (5=Exceptional | 4=Highly Effective | 3=Proficient | 2=Inconsistent | 1=Unsatisfactory | N/A)",
    avgLbl:"Average",
    commentLbl:"Overall Comment", goalLbl:"Next Period Goals",
    commentPh:"Enter overall evaluation", goalPh:"Enter goals for next period",
    noEval:"No evaluations found", placeholder:"Please select",
    save:"Save", cancel:"Cancel", del:"Delete", edit:"Edit", confirmDel:"Are you sure?",
    allEmp:"All Employees", downloadPdf:"Download PDF",
    uploadSigned:"Upload Signed", viewSigned:"View Signed",
    statusSigned:"Signed", statusPending:"Pending",
    items:[
      {key:"c1",label:"Job Performance Skills and Proficiency"},
      {key:"c2",label:"Skills and Knowledge Required"},
      {key:"c3",label:"Plan, Organize, and Prioritize Work"},
      {key:"c4",label:"Accountability and Timely Completion"},
      {key:"c5",label:"Improving Efficiency"},
      {key:"c6",label:"Effective Communication"},
      {key:"c7",label:"Ability to Work Independently"},
      {key:"c8",label:"Collaborative Teamwork"},
      {key:"c9",label:"Accept Additional Responsibilities"},
      {key:"c10",label:"Reliability (Attendance, Punctuality)"},
      {key:"c11",label:"Problem-Solving and Judgment"},
    ],
    commentCol:"Comment", goalCol:"Goal",
    newEmpTitle:"New Employee Evaluation", newEmpSub:"Evaluate new employee adaptation and performance",
    newListTab:"View Evals", newAddTab:"+ New Eval",
    newEmpNameLbl:"Employee Name *", newEmpNumLbl:"Employee No.", newDeptLbl:"Department", newHireLbl:"Hire Date",
    newEval1Lbl:"Evaluator 1 *", newEval2Lbl:"Evaluator 2", newEvalDateLbl:"Eval Date",
    newCriteria:["Maximum Capability","Work Quality","Work Consistency","Communication Skills","Independent Work","Initiative/Proactivity","Teamwork","Productivity","Creativity","Honesty","Diligence","Colleague Relations","Customer Service","Technical Skills","Reliability","Punctuality","Attendance"],
    newRatings:["5","4","3","2","1","N/A"],
    newStrengthLbl:"Key Strengths", newImproveLbl:"Areas Requiring Improvement",
    newPrevGoalLbl:"Achievement of Previous Goals", newNextGoalLbl:"Goals for Next Period",
    newEmpCommentLbl:"Employee Comments", newEval1CommentLbl:"Evaluator 1 Comments", newEval2CommentLbl:"Evaluator 2 Comments",
    noNewEval:"No new employee evaluations",
    noteTitle:"Performance Notes", noteSub:"Record performance evidence and notable incidents regularly",
    noteListTab:"View Notes", noteAddTab:"+ New Note",
    noteEmpLbl:"Employee *", noteDateLbl:"Date *", noteCatLbl:"Category",
    noteContentLbl:"Content *", noteContentPh:"Describe specific behavior, action, or outcome",
    noteCats:["Outstanding","Needs Improvement","Incident","Customer Feedback","Team Contribution"],
    noNote:"No notes recorded",
  },
  emp:{
    title:"Employee Management", sub:"Register and manage employees.",
    addTitle:"Add Employee", editTitle:"Edit Employee", listTitle:"Employee List",
    nameLbl:"Name *", deptLbl:"Department", posLbl:"Position", joinLbl:"Join Date", adjLbl:"Vacation Adjust (±days)",
    namePh:"John Doe", deptPh:"Development", posPh:"Manager",
    colName:"Name", colDept:"Department", colPos:"Position", colJoin:"Join Date", colVac:"Allocated",
    save:"Save", cancel:"Cancel", del:"Delete", edit:"Edit", confirmDel:"Are you sure?",
    noEmp:"No employees yet",
  },
  cal:{ title:"Attendance Calendar", holiday:"US Federal Holiday" },
  safety:{
    title:"Quarterly Safety Training", sub:"Record quarterly safety training and upload signed documents.",
    listTab:"View Records", addTab:"+ New Record",
    addTitle:"Add Safety Training Record", editTitle:"Edit Safety Training Record",
    quarterLbl:"Quarter *", yearLbl:"Year *", dateLbl:"Training Date",
    managerLbl:"Manager", notesLbl:"Notes",
    empSelLbl:"Select Attendees *", empSelSub:"Select employees to include in the PDF",
    save:"Save", cancel:"Cancel", del:"Delete", edit:"Edit", confirmDel:"Are you sure?",
    downloadPdf:"Download PDF", uploadSigned:"Upload Signed", viewSigned:"View Signed",
    noRecord:"No records", loading:"Loading...",
    quarters:["Q1 (Jan–Mar)","Q2 (Apr–Jun)","Q3 (Jul–Sep)","Q4 (Oct–Dec)"],
    statusSigned:"Signed", statusPending:"Pending",
    selectAll:"Select All", deselectAll:"Deselect All",
    placeholder:"Please select",
  },
  sep:{
    title:"HR Records", sub:"Manage termination and resignation documents.",
    tabTerm:"Terminations", tabResign:"Resignations",
    listTab:"View Records", addTab:"+ New Record",
    empLbl:"Employee Name *", posLbl:"Position", deptLbl:"Department", dateLbl:"Date *",
    employerLbl:"Employer", conductedLbl:"Conducted By",
    witnessLbl:"Witness Present", empResponseLbl:"Employee Response",
    termTitle:"Termination Record", termSub:"Create termination documentation and save as PDF",
    reasonLbl:"Reason for Termination (Summary)", detailLbl:"Detailed Reasons (use A. B. C. format)",
    impactLbl:"Cumulative Impact", warningLbl:"Verbal Warnings Issued", writtenLbl:"Written Notice Issued",
    legalLbl:"Legal Compliance Notes",
    preparedLbl:"Prepared By (Name)", preparedTitleLbl:"Title", reviewedLbl:"Reviewed By (Name)", reviewedTitleLbl:"Title",
    resignTitle:"Resignation Record", resignSub:"Create resignation documentation and save as PDF",
    resignReasonLbl:"Reason for Resignation", noticeDateLbl:"Notice Date", lastDayLbl:"Last Day of Work",
    severanceLbl:"Severance Pay ($)", severanceDetailLbl:"Severance Details",
    accrualLbl:"Accrued Vacation Payout", benefitsLbl:"Benefits End Date",
    exitInterviewLbl:"Exit Interview Conducted", equipmentLbl:"Equipment Returned", accessLbl:"System Access Revoked",
    save:"Save", cancel:"Cancel", del:"Delete", edit:"Edit", confirmDel:"Are you sure?",
    downloadPdf:"Download PDF", uploadSigned:"Upload Signed", viewSigned:"View Signed",
    noRecord:"No records", loading:"Loading...",
    statusSigned:"Signed", statusPending:"Pending",
  },
  policy:{
    title:"Company Policy", sub:"Work hours, vacation, and sick leave policy.",
    workTitle:"Work Hours", breakTitle:"Break Times", vacTitle:"Paid Vacation (by Service Length)",
    sickTitle:"Paid Sick Leave", rulesTitle:"Vacation Rules", holidayTitle:"Holiday Policy",
    workDays:"Work Days", hours:"Hours", annualLimit:"Annual Limit", carryOver:"Carry Over",
    noPayOut:"Unused Payout", docReq:"Documentation",
    carryVal:"Yes (up to 40 hrs)", noPayVal:"No payout", docVal:"3+ consecutive days",
    holidayNote:"The company observes all US Federal Holidays; however, work may be required depending on workflow.\n• When Closed: Paid day off\n• Work Notice: At least 2 days advance notice",
    rules:["Must be requested at least 1 month in advance.","Max 7 consecutive days unless approved by executive management.","Fairness among employees must be considered.","In case of emergencies, the notice period may be shortened.","Unused paid vacation expires at year-end; no payout will be provided."],
    dayUnit:"days", hrUnit:"hrs",
    conductTitle:"Workplace Conduct Policy",
    conductSub:"Cell Phone, Music & Audio, and Forms of Address",
    phoneTitle:"Cell Phone Policy",
    phoneRules:[
      "Personal cell phones must be stored in the employee's designated locker during all working hours.",
      "Cell phones are not permitted on the work floor. Employees needing to make or receive urgent calls must do so during designated break times away from the work floor.",
      "Employees who require their personal cell phone for family emergencies or urgent personal matters may request an exception from their supervisor. Approved exceptions must be handled away from the work floor.",
      "Smart watches and other wearable devices capable of receiving calls or messages are subject to the same restrictions as cell phones.",
      "Employees using a company-issued phone, or those who have been granted permission to use a personal phone for work purposes, are exempt from this policy.",
    ],
    musicTitle:"Music & Audio Policy",
    musicRules:[
      "The use of any personal audio device (wired or wireless) worn on or in the ears is strictly prohibited on the work floor.",
      "Playing music through a shared speaker at a low volume is permitted, provided it does not disturb other employees or interfere with normal operations.",
      "Volume must remain at a level that does not exceed ambient workplace noise. If a coworker requests that the volume be lowered, the request must be respected immediately.",
      "Music selection should be appropriate for a professional work environment. Content that is offensive, explicit, or disruptive is not permitted.",
      "In areas where customer interaction or focused work is required, music may be prohibited at the discretion of the supervisor.",
    ],
    addressTitle:"Respectful Forms of Address",
    addressRules:[
      "All employees are required to address one another using respectful honorifics — \"님\" (nim) or \"씨\" (ssi) — when referring to or speaking with colleagues.",
      "This policy applies to all staff regardless of position or seniority and is intended to foster a respectful and professional work environment.",
    ],
  },
  calToday:"Today",
  months:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
  weekdays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
  today:(d)=>d.toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric",weekday:"long"}),
  langBtn:"한국어", darkBtn:"Dark", lightBtn:"Light", dayUnit:"d",
};

// ── Español (América Latina) — las claves no traducidas usan EN ──────────
export const ES = {
  ...EN,
  appName:"SPRINGBLINDS TEAM", appSub:"Gestión de asistencia y desempeño del personal",
  login:"Iniciar sesión", id:"Usuario", pw:"Contraseña", loginErr:"Usuario o contraseña incorrectos.",
  nav:{ ...EN.nav, dash:"Panel", leave:"Asistencia", eval:"Desempeño", emp:"Empleados", cal:"Calendario", sep:"Registros de RR. HH.", safety:"Capacitación de seguridad", policy:"Políticas", logout:"Cerrar sesión", lunch:"Almuerzo" },
  dash:{
    ...EN.dash,
    todayAbsent:"Ausentes hoy", monthLeave:"Este mes", thisWeekLeave:"Libres esta semana", yearEval:"Evaluaciones del año", safetyQ:"Capacitación de seguridad",
    empLeave:"Estado de ausencias del personal", recent:"Registros recientes", noRecord:"No hay registros", collapse:"Contraer", expand:"Expandir",
    onDuty:"En horario laboral", offHours:"Fuera de horario", remainTitle:"Días restantes por empleado",
    remainVac:"Vacaciones", remainSick:"Baja por enfermedad",
  },
  leave:{
    ...EN.leave,
    title:"Gestión de asistencia", sub:"Registra y consulta vacaciones, días por enfermedad, medios días y notas.",
    listTab:"Ver registros", addTab:"+ Nuevo registro", addTabEmp:"+ Solicitar",
    addTitle:"Agregar registro", editTitle:"Editar registro",
    empSel:"Empleado *", typeSel:"Tipo *", dateLbl:"Fecha *", daysLbl:"Días",
    reasonLbl:"Motivo", noteLbl:"Notas",
    placeholder:"Selecciona una opción", reasonPh:"Ej.: asunto personal, resfriado, cita médica...", notePh:"Notas adicionales",
    save:"Guardar", cancel:"Cancelar", del:"Eliminar", edit:"Editar", confirmDel:"¿Seguro?",
    allEmp:"Todos los empleados", allType:"Todos los tipos",
    colEmp:"Empleado", colType:"Tipo", colDate:"Fecha", colDays:"Días", colReason:"Motivo", colNote:"Notas",
    remainVac:"Vacaciones", remainSick:"Baja por enfermedad",
    vacInfo:"Vacaciones pagadas: solicitar con 1 mes de anticipación. Máximo 7 días consecutivos.",
    sickInfo:"Baja por enfermedad pagada: 5 días al año. Se requiere comprobante a partir de 3 días consecutivos.",
    holiday:"Feriado federal de EE. UU.", loading:"Cargando...",
    importTab:"Importar NGteco",
    importTitle:"Importar hoja de horas",
    importSub:"Sube el archivo de Excel exportado de Cloud para importar automáticamente los registros de asistencia.",
    importBtn:"Seleccionar archivo de Excel (.xlsx)",
    importPreview:"Vista previa",
    importConfirm:"Ejecutar importación",
    importSuccess:"registros importados",
    importSkip:"duplicados omitidos",
    importError:"Error al leer el archivo. Verifica que tenga el formato del Reporte de hoja de horas",
    importCols:"Requerido: Name, Date, Timesheet, Clock In, Clock Out, Clock Time(h), Total Break Time(h), Total Work Time(h), Total Time(h), Total Overtime Time(h), Abnormal Situation",
    importDupKey:"Se omitirán los registros con el mismo nombre y fecha",
    noClockOut:"Sin registro de salida",
    colName:"Empleado", colTimesheet:"Horario",
    colIn:"Entrada", colOut:"Salida",
    colClock:"Reloj(h)", colBreak:"Descanso(h)",
    colWork:"Trabajo(h)", colTotal:"Total(h)",
    colOT:"Extra(h)", colAbnormal:"Excepción",
    attendTab:"Asistencia", leaveTab:"Ausencias · Notas",
    late:"Tarde", earlyOut:"Salida temprana", normal:"Normal", notClockedOut:"Sin registro de salida",
    lateStd:"Criterio de tardanza", filterAll:"Todos", filterLate:"Solo tardanzas", filterAbnormal:"Excepción",
    noData:"Sin datos",
    totalRecords:"Total de registros", statusHdr:"Estado", abnormalHdr:"Excepción",
  },
  eval:{
    ...EN.eval,
    title:"Gestión de desempeño", sub:"Consulta evaluaciones, evaluaciones de nuevos empleados y notas.",
    tabPerf:"Evaluación de desempeño", tabNew:"Evaluación de nuevo empleado", tabNote:"Notas de desempeño",
    listTab:"Ver evaluaciones", addTab:"+ Nueva evaluación",
    addTitle:"Escribir evaluación", editTitle:"Editar evaluación",
    empSel:"Empleado *", periodLbl:"Período *", evalDateLbl:"Fecha de evaluación *",
    evaluatorLbl:"Evaluador", evaluator2Lbl:"Evaluador 2",
    goalsLbl:"Metas de desempeño", outstandingLbl:"Áreas de desempeño sobresaliente", improveLbl:"Áreas por mejorar",
    readinessLbl:"Preparación para mayores responsabilidades", nextGoalsLbl:"Metas de desempeño del próximo año", nextDevLbl:"Metas de desarrollo del próximo año",
    empCommentLbl:"Comentarios del empleado",
    scoreTitle:"Competencias de desempeño (5=Excepcional | 4=Muy efectivo | 3=Competente | 2=Inconsistente | 1=Insatisfactorio | N/A)",
    avgLbl:"Promedio",
    commentLbl:"Comentario general", goalLbl:"Metas del próximo período",
    commentPh:"Escribe la evaluación general", goalPh:"Escribe las metas del próximo período",
    noEval:"No hay evaluaciones", placeholder:"Selecciona una opción",
    save:"Guardar", cancel:"Cancelar", del:"Eliminar", edit:"Editar", confirmDel:"¿Seguro?",
    allEmp:"Todos los empleados", downloadPdf:"Descargar PDF",
    uploadSigned:"Subir firmado", viewSigned:"Ver firmado",
    statusSigned:"Firmado", statusPending:"Pendiente",
    items:[
      {key:"c1",label:"Habilidades y dominio del trabajo"},
      {key:"c2",label:"Habilidades y conocimientos requeridos"},
      {key:"c3",label:"Planificar, organizar y priorizar el trabajo"},
      {key:"c4",label:"Responsabilidad y cumplimiento a tiempo"},
      {key:"c5",label:"Mejora de la eficiencia"},
      {key:"c6",label:"Comunicación efectiva"},
      {key:"c7",label:"Capacidad de trabajar de forma independiente"},
      {key:"c8",label:"Trabajo en equipo y colaboración"},
      {key:"c9",label:"Disposición para asumir responsabilidades adicionales"},
      {key:"c10",label:"Confiabilidad (asistencia, puntualidad)"},
      {key:"c11",label:"Resolución de problemas y criterio"},
    ],
    commentCol:"Comentario", goalCol:"Meta",
    newEmpTitle:"Evaluación de nuevo empleado", newEmpSub:"Evalúa la adaptación y el desempeño del nuevo empleado",
    newListTab:"Ver evaluaciones", newAddTab:"+ Nueva evaluación",
    newEmpNameLbl:"Nombre del empleado *", newEmpNumLbl:"N.º de empleado", newDeptLbl:"Departamento", newHireLbl:"Fecha de contratación",
    newEval1Lbl:"Evaluador 1 *", newEval2Lbl:"Evaluador 2", newEvalDateLbl:"Fecha de evaluación",
    newCriteria:["Capacidad máxima","Calidad del trabajo","Constancia en el trabajo","Habilidades de comunicación","Trabajo independiente","Iniciativa/proactividad","Trabajo en equipo","Productividad","Creatividad","Honestidad","Diligencia","Relación con compañeros","Servicio al cliente","Habilidades técnicas","Confiabilidad","Puntualidad","Asistencia"],
    newStrengthLbl:"Principales fortalezas", newImproveLbl:"Áreas por mejorar",
    newPrevGoalLbl:"Cumplimiento de metas anteriores", newNextGoalLbl:"Metas del próximo período",
    newEmpCommentLbl:"Comentarios del empleado", newEval1CommentLbl:"Comentarios del evaluador 1", newEval2CommentLbl:"Comentarios del evaluador 2",
    noNewEval:"No hay evaluaciones de nuevos empleados",
    noteTitle:"Notas de desempeño", noteSub:"Registra periódicamente evidencias de desempeño e incidentes destacados",
    noteListTab:"Ver notas", noteAddTab:"+ Nueva nota",
    noteEmpLbl:"Empleado *", noteDateLbl:"Fecha *", noteCatLbl:"Categoría",
    noteContentLbl:"Contenido *", noteContentPh:"Describe el comportamiento, la acción o el resultado concreto",
    noteCats:["Sobresaliente","Necesita mejorar","Incidente","Comentario de cliente","Aporte al equipo"],
    noNote:"No hay notas registradas",
  },
  emp:{
    title:"Gestión de empleados", sub:"Registra y administra a los empleados.",
    addTitle:"Agregar empleado", editTitle:"Editar empleado", listTitle:"Lista de empleados",
    nameLbl:"Nombre *", deptLbl:"Departamento", posLbl:"Puesto", joinLbl:"Fecha de ingreso", adjLbl:"Ajuste de vacaciones (±días)",
    namePh:"Juan Pérez", deptPh:"Desarrollo", posPh:"Gerente",
    colName:"Nombre", colDept:"Departamento", colPos:"Puesto", colJoin:"Fecha de ingreso", colVac:"Asignados",
    save:"Guardar", cancel:"Cancelar", del:"Eliminar", edit:"Editar", confirmDel:"¿Seguro?",
    noEmp:"Aún no hay empleados",
  },
  cal:{ title:"Calendario de asistencia", holiday:"Feriado federal de EE. UU." },
  safety:{
    ...EN.safety,
    title:"Capacitación trimestral de seguridad", sub:"Registra la capacitación trimestral de seguridad y sube los documentos firmados.",
    listTab:"Ver registros", addTab:"+ Nuevo registro",
    addTitle:"Agregar registro de capacitación de seguridad", editTitle:"Editar registro de capacitación de seguridad",
    quarterLbl:"Trimestre *", yearLbl:"Año *", dateLbl:"Fecha de la capacitación",
    managerLbl:"Gerente", notesLbl:"Notas",
    empSelLbl:"Seleccionar asistentes *", empSelSub:"Selecciona los empleados que se incluirán en el PDF",
    save:"Guardar", cancel:"Cancelar", del:"Eliminar", edit:"Editar", confirmDel:"¿Seguro?",
    downloadPdf:"Descargar PDF", uploadSigned:"Subir firmado", viewSigned:"Ver firmado",
    noRecord:"Sin registros", loading:"Cargando...",
    quarters:["T1 (ene–mar)","T2 (abr–jun)","T3 (jul–sep)","T4 (oct–dic)"],
    statusSigned:"Firmado", statusPending:"Pendiente",
    selectAll:"Seleccionar todo", deselectAll:"Quitar selección",
    placeholder:"Selecciona una opción",
  },
  sep:{
    title:"Registros de RR. HH.", sub:"Administra los documentos de despido y renuncia.",
    tabTerm:"Despidos", tabResign:"Renuncias",
    listTab:"Ver registros", addTab:"+ Nuevo registro",
    empLbl:"Nombre del empleado *", posLbl:"Puesto", deptLbl:"Departamento", dateLbl:"Fecha *",
    employerLbl:"Empleador", conductedLbl:"Realizado por",
    witnessLbl:"Testigo presente", empResponseLbl:"Respuesta del empleado",
    termTitle:"Registro de despido", termSub:"Crea la documentación del despido y guárdala como PDF",
    reasonLbl:"Motivo del despido (resumen)", detailLbl:"Motivos detallados (usa el formato A. B. C.)",
    impactLbl:"Impacto acumulado", warningLbl:"Advertencias verbales emitidas", writtenLbl:"Aviso por escrito emitido",
    legalLbl:"Notas de cumplimiento legal",
    preparedLbl:"Preparado por (nombre)", preparedTitleLbl:"Cargo", reviewedLbl:"Revisado por (nombre)", reviewedTitleLbl:"Cargo",
    resignTitle:"Registro de renuncia", resignSub:"Crea la documentación de la renuncia y guárdala como PDF",
    resignReasonLbl:"Motivo de la renuncia", noticeDateLbl:"Fecha de aviso", lastDayLbl:"Último día de trabajo",
    severanceLbl:"Indemnización ($)", severanceDetailLbl:"Detalles de la indemnización",
    accrualLbl:"Pago de vacaciones acumuladas", benefitsLbl:"Fecha de fin de beneficios",
    exitInterviewLbl:"Entrevista de salida realizada", equipmentLbl:"Equipo devuelto", accessLbl:"Acceso a sistemas revocado",
    save:"Guardar", cancel:"Cancelar", del:"Eliminar", edit:"Editar", confirmDel:"¿Seguro?",
    downloadPdf:"Descargar PDF", uploadSigned:"Subir firmado", viewSigned:"Ver firmado",
    noRecord:"Sin registros", loading:"Cargando...",
    statusSigned:"Firmado", statusPending:"Pendiente",
  },
  policy:{
    ...EN.policy,
    title:"Políticas de la empresa", sub:"Políticas de horario, vacaciones y baja por enfermedad.",
    workTitle:"Horario de trabajo", breakTitle:"Horarios de descanso", vacTitle:"Vacaciones pagadas (según antigüedad)",
    sickTitle:"Baja por enfermedad pagada", rulesTitle:"Reglas de vacaciones", holidayTitle:"Política de feriados",
    workDays:"Días laborales", hours:"Horas", annualLimit:"Límite anual", carryOver:"Traspaso al año siguiente",
    noPayOut:"Pago de días no usados", docReq:"Comprobante",
    carryVal:"Sí (hasta 40 h)", noPayVal:"No se pagan", docVal:"3 o más días consecutivos",
    holidayNote:"La empresa respeta todos los feriados federales de EE. UU.; sin embargo, puede ser necesario trabajar según la carga de trabajo.\n• Si la empresa cierra: día libre pagado\n• Aviso de trabajo: al menos 2 días de anticipación",
    rules:["Se debe solicitar con al menos 1 mes de anticipación.","Máximo 7 días consecutivos, salvo aprobación de la gerencia ejecutiva.","Se debe considerar la equidad entre los empleados.","En caso de emergencia, el plazo de aviso puede acortarse.","Las vacaciones pagadas no usadas vencen al final del año y no se pagan."],
    dayUnit:"días", hrUnit:"h",
    conductTitle:"Política de conducta en el trabajo",
    conductSub:"Teléfono celular, música y audio, y trato entre compañeros",
    phoneTitle:"Política de teléfonos celulares",
    phoneRules:[
      "Los teléfonos celulares personales deben guardarse en el casillero asignado durante todo el horario de trabajo.",
      "No se permiten celulares en el área de trabajo. Quien necesite hacer o recibir una llamada urgente debe hacerlo en los descansos, lejos del área de trabajo.",
      "Quien necesite su celular por una emergencia familiar o un asunto personal urgente puede pedir una excepción a su supervisor. Las excepciones aprobadas deben atenderse lejos del área de trabajo.",
      "Los relojes inteligentes y otros dispositivos que reciban llamadas o mensajes están sujetos a las mismas restricciones que los celulares.",
      "Quienes usen un teléfono de la empresa, o tengan permiso para usar su teléfono personal para el trabajo, están exentos de esta política.",
    ],
    musicTitle:"Política de música y audio",
    musicRules:[
      "Está estrictamente prohibido usar audífonos personales (con cable o inalámbricos) en el área de trabajo.",
      "Se permite poner música a bajo volumen en un altavoz compartido, siempre que no moleste a otros empleados ni afecte las operaciones normales.",
      "El volumen no debe superar el ruido ambiente del lugar de trabajo. Si un compañero pide bajar el volumen, se debe hacer de inmediato.",
      "La música debe ser apropiada para un entorno de trabajo profesional. No se permite contenido ofensivo, explícito o que distraiga.",
      "En áreas de atención al cliente o de trabajo que requiera concentración, el supervisor puede prohibir la música.",
    ],
    addressTitle:"Trato respetuoso entre compañeros",
    addressRules:[
      "Todos los empleados deben dirigirse a sus compañeros con respeto, usando los honoríficos coreanos \"님\" (nim) o \"씨\" (ssi) al hablar con ellos o referirse a ellos.",
      "Esta política aplica a todo el personal, sin importar el puesto o la antigüedad, y busca fomentar un ambiente de trabajo respetuoso y profesional.",
    ],
  },
  calToday:"Hoy",
  months:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],
  weekdays:["dom","lun","mar","mié","jue","vie","sáb"],
  today:(d)=>d.toLocaleDateString("es-US",{year:"numeric",month:"long",day:"numeric",weekday:"long"}),
  langBtn:"Español", darkBtn:"Oscuro", lightBtn:"Claro", dayUnit:"d",
};

export function calcGrade(a){if(a>=90)return"S";if(a>=80)return"A";if(a>=70)return"B";if(a>=60)return"C";return"D";}

export const getStyle = (dark) => `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
  :root{
    ${dark
      ?"--bg:#0f1117;--sf:#1a1d27;--sf2:#22263a;--bd:#2e3352;--ac:#4a7ab5;--ac2:#6ea8e0;--gr:#34d399;--ye:#fbbf24;--re:#f87171;--or:#fb923c;--tx:#e2e8f0;--tx2:#94a3b8;--tx3:#64748b;"
      :"--bg:#f4f6fb;--sf:#ffffff;--sf2:#f0f2f8;--bd:#dde2ee;--ac:#1e3a5f;--ac2:#2e5fa3;--gr:#059669;--ye:#d97706;--re:#dc2626;--or:#ea580c;--tx:#1e293b;--tx2:#475569;--tx3:#94a3b8;"
    }
    --r:12px;--sh:0 4px 24px rgba(0,0,0,${dark?"0.4":"0.08"});
  }
  html,body{overscroll-behavior-y:contain;}
  body{font-family:'Noto Sans KR',sans-serif;background:var(--bg);color:var(--tx);min-height:100vh;}
  .app{display:flex;min-height:100vh;}
  .sidebar{width:220px;min-height:100vh;background:var(--sf);border-right:1px solid var(--bd);padding:24px 0;display:flex;flex-direction:column;position:fixed;top:0;left:0;z-index:200;transition:transform .25s;}
  .sbl{padding:0 12px 24px;border-bottom:1px solid var(--bd);font-size:20px;line-height:1.2;text-align:left;}
  .sbl span{color:var(--ac);}
  .sbn{padding:16px 12px;flex:1;overflow-y:auto;}
  .nss{font-size:10px;font-weight:700;color:var(--tx3);letter-spacing:1.5px;text-transform:uppercase;padding:8px 8px 4px;}
  .ni{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;cursor:pointer;font-size:14px;color:var(--tx2);transition:all .15s;margin-bottom:2px;}
  .ni:hover{background:var(--sf2);color:var(--tx);}
  .ni.active{background:rgba(74,122,181,.15);color:var(--ac);font-weight:500;}
  .nic{width:20px;display:flex;align-items:center;justify-content:center;color:var(--tx3);}
  .ni.active .nic{color:var(--ac);}
  .topbar{display:none;position:fixed;top:0;left:0;right:0;height:56px;background:var(--sf);border-bottom:1px solid var(--bd);z-index:300;align-items:center;justify-content:space-between;padding:0 16px;}
  .tbt{font-size:14px;font-weight:700;white-space:nowrap;line-height:1.2;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;margin:0 8px;} .tb-user{display:inline-flex;} .topbar>*{align-self:center;} .tbt span{color:var(--ac);}
  .hbg{background:none;border:none;cursor:pointer;font-size:24px;color:var(--tx);padding:0;width:36px;height:36px;display:flex;align-items:center;justify-content:center;flex-shrink:0;line-height:1;}
  .topbar{align-items:center;} .topbar button,.topbar svg{vertical-align:middle;}
  .overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:190;}
  .bnav{display:none;position:fixed;bottom:0;left:0;right:0;background:var(--sf);border-top:1px solid var(--bd);z-index:200;padding:6px 0 env(safe-area-inset-bottom,8px);}
  .bni{display:flex;flex-direction:column;align-items:center;gap:2px;padding:4px 0;cursor:pointer;color:var(--tx3);font-size:10px;flex:1;}
  .bni.active{color:var(--ac);}
  .bni-icon{font-size:20px;}
  .main{margin-left:220px;padding:32px;flex:1;max-width:1300px;}
  @media(max-width:768px){
    .sidebar{transform:translateX(-100%);top:56px;height:calc(100% - 56px);min-height:0;padding-top:12px;overflow-y:auto;} .sidebar.open{transform:translateX(0);} .sbl{display:none;}
    .tb-user{display:none;} .notif-pop{position:fixed!important;top:62px!important;left:0!important;right:0!important;width:min(360px,calc(100vw - 24px))!important;margin:0 auto!important;}
    .overlay.open{display:block;} .topbar{display:flex;} .bnav{display:none!important;}
    .main{padding-bottom:20px!important;}
    .main{margin-left:0;padding:14px;padding-top:70px;padding-bottom:80px;max-width:100%;}
    .sg{grid-template-columns:repeat(2,1fr)!important;}
    .rc{min-width:0!important;} .rrow{flex-wrap:wrap!important;} .rrow span:first-child{white-space:normal!important;word-break:break-word!important;flex:1!important;} .rrow span:last-child{white-space:nowrap!important;flex-shrink:0!important;} .rn{font-size:12px!important;white-space:normal!important;word-break:break-word!important;}
    .fg{grid-template-columns:1fr!important;} .ff{grid-column:1!important;}
    .pg{grid-template-columns:1fr!important;} .d2{grid-template-columns:1fr!important;}
    .rg{grid-template-columns:1fr 1fr!important;}
    .cal-day{min-height:72px!important;padding:4px!important;}
    .cal-dn{font-size:12px!important;} .cal-hn{font-size:9px!important;}
    .pt{font-size:19px!important;} .card{padding:14px!important;}
    .hm{display:none!important;} .hm-mobile{display:flex!important;} .es{grid-template-columns:repeat(3,1fr)!important;}
    .dash-bottom{grid-template-columns:1fr!important;}
    .pr{flex-wrap:wrap!important;gap:4px!important;}
    .pr span:last-child{text-align:right;word-break:break-word;}
    .approval-btns{flex-direction:column!important;width:100%!important;}
    .approval-btns button{width:100%!important;}
    .rec-btns{flex-wrap:wrap!important;gap:6px!important;}
    .rec-btns button,.rec-btns label{flex:1!important;min-width:80px!important;text-align:center!important;}
  }
  .ph{margin-bottom:24px;} .pt{font-size:24px;font-weight:700;letter-spacing:-.5px;}
  .ps{font-size:14px;color:var(--tx2);margin-top:4px;}
  .card{background:var(--sf);border:1px solid var(--bd);border-radius:var(--r);padding:24px;margin-bottom:20px;box-shadow:var(--sh);}
  .ct{font-size:15px;font-weight:700;margin-bottom:16px;display:flex;align-items:center;gap:8px;}
  .sg{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:20px;}
  .sc{background:var(--sf);border:1px solid var(--bd);border-radius:var(--r);padding:20px;position:relative;overflow:hidden;box-shadow:var(--sh);}
  .sc::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;}
  .sc.bl::before{background:var(--ac);} .sc.pu::before{background:var(--ac2);}
  .sc.gr::before{background:var(--gr);} .sc.or::before{background:var(--or);}
  .sl{font-size:12px;color:var(--tx3);font-weight:500;margin-bottom:8px;}
  .sv{font-size:28px;font-weight:700;font-family:'DM Mono',monospace;}
  .sc.bl .sv{color:var(--ac);} .sc.pu .sv{color:var(--ac2);} .sc.gr .sv{color:var(--gr);} .sc.or .sv{color:var(--or);}
  .fg{display:grid;grid-template-columns:1fr 1fr;gap:16px;}
  .ff{grid-column:1/-1;}
  .fl{display:flex;flex-direction:column;gap:6px;}
  .fl label{font-size:12px;font-weight:600;color:var(--tx2);letter-spacing:.5px;}
  .fl input,.fl select,.fl textarea{background:var(--sf2);border:1px solid var(--bd);border-radius:8px;padding:10px 12px;color:var(--tx);font-size:14px;font-family:inherit;outline:none;transition:border-color .15s;}
  .fl input:focus,.fl select:focus,.fl textarea:focus{border-color:var(--ac);}
  .fl textarea{resize:vertical;min-height:80px;}
  .fl select option{background:var(--sf);}
  .btn{padding:10px 20px;border-radius:8px;border:none;cursor:pointer;font-size:14px;font-weight:600;font-family:inherit;transition:all .15s;}
  .bp{background:var(--ac);color:#fff;} .bp:hover{opacity:.88;transform:translateY(-1px);}
  .bd2{background:rgba(220,38,38,.08);color:var(--re);border:1px solid rgba(220,38,38,.2);}
  .bd2:hover{background:rgba(220,38,38,.18);}
  .bs{padding:6px 12px;font-size:12px;}
  .btg{padding:6px 14px;border-radius:20px;border:1px solid var(--bd);background:var(--sf2);color:var(--tx2);cursor:pointer;font-size:12px;font-weight:600;font-family:inherit;}
  .btg:hover{border-color:var(--ac);color:var(--ac);}
  .bsec{background:var(--sf2);color:var(--tx2);border:1px solid var(--bd);}
  .tw{overflow-x:auto;-webkit-overflow-scrolling:touch;}
  table{width:100%;border-collapse:collapse;font-size:14px;}
  th{text-align:left;padding:10px 14px;font-size:11px;font-weight:700;color:var(--tx3);text-transform:uppercase;letter-spacing:.8px;border-bottom:1px solid var(--bd);}
  td{padding:11px 14px;border-bottom:1px solid var(--bd);vertical-align:middle;}
  tr:last-child td{border-bottom:none;} tr:hover td{background:var(--sf2);}
  .bg{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;}
  .b0{background:rgba(30,58,95,.1);color:var(--ac);} .b1{background:rgba(220,38,38,.1);color:var(--re);}
  .b2{background:rgba(124,58,237,.1);color:var(--ac2);} .b3{background:rgba(217,119,6,.1);color:var(--ye);}
  .etag{display:inline-flex;align-items:center;gap:6px;background:var(--sf2);border:1px solid var(--bd);border-radius:20px;padding:2px 10px;font-size:12px;}
  .edot{width:8px;height:8px;border-radius:50%;background:var(--gr);}
  .lw{min-height:100vh;display:flex;align-items:center;justify-content:center;background:var(--bg);padding:16px;}
  .lc{background:var(--sf);border:1px solid var(--bd);border-radius:16px;padding:40px 32px;width:100%;max-width:380px;text-align:center;box-shadow:var(--sh);}
  .lo{font-size:32px;margin-bottom:8px;} .lt{font-size:22px;font-weight:700;margin-bottom:4px;}
  .lsb{font-size:13px;color:var(--tx3);margin-bottom:32px;}
  .lf{text-align:left;margin-bottom:16px;}
  .lf label{font-size:12px;color:var(--tx2);font-weight:600;display:block;margin-bottom:6px;}
  .lf input{width:100%;background:var(--sf2);border:1px solid var(--bd);border-radius:8px;padding:12px 14px;color:var(--tx);font-size:14px;font-family:inherit;outline:none;}
  .lf input:focus{border-color:var(--ac);}
  .lb{width:100%;background:var(--ac);color:#fff;border:none;border-radius:8px;padding:13px;font-size:15px;font-weight:700;cursor:pointer;margin-top:8px;font-family:inherit;}
  .lb:hover{opacity:.88;} .le{color:var(--re);font-size:13px;margin-top:12px;}
  .lbt{display:flex;justify-content:center;gap:8px;margin-top:20px;}
  .tabs{display:flex;gap:4px;background:var(--sf2);border-radius:10px;padding:4px;margin-bottom:20px;width:fit-content;flex-wrap:wrap;}
  .tab{padding:8px 16px;border-radius:7px;border:none;cursor:pointer;font-size:13px;font-weight:600;font-family:inherit;color:var(--tx2);background:none;}
  .tab.active{background:var(--sf);color:var(--tx);box-shadow:var(--sh);}
  .fb{display:flex;gap:10px;margin-bottom:16px;flex-wrap:wrap;}
  .fb select,.fb input{background:var(--sf2);border:1px solid var(--bd);border-radius:8px;padding:8px 12px;color:var(--tx);font-size:13px;font-family:inherit;outline:none;}
  .div{border:none;border-top:1px solid var(--bd);margin:20px 0;}
  .empty{text-align:center;color:var(--tx3);padding:40px;font-size:14px;}
  .loading{text-align:center;color:var(--tx3);padding:40px;}
  .gS{color:var(--ye);font-weight:700;} .gA{color:var(--gr);font-weight:700;}
  .gB{color:var(--ac);font-weight:700;} .gC{color:var(--tx3);font-weight:700;} .gD{color:var(--re);font-weight:700;}
  .hb{display:inline-flex;align-items:center;gap:6px;background:rgba(239,68,68,.1);color:#ef4444;border:1px solid rgba(239,68,68,.25);border-radius:8px;padding:6px 12px;font-size:13px;font-weight:600;margin-top:6px;}
  .ib{background:rgba(239,68,68,.06);border:1px solid rgba(239,68,68,.2);border-radius:10px;padding:12px 14px;font-size:13px;color:var(--tx2);margin-top:4px;}
  .ch{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;flex-wrap:wrap;gap:8px;}
  .cn{display:flex;align-items:center;gap:10px;}
  .cn button{background:var(--sf2);border:1px solid var(--bd);border-radius:8px;padding:6px 14px;cursor:pointer;color:var(--tx);font-size:16px;font-family:inherit;}
  .cm{font-size:18px;font-weight:700;min-width:130px;text-align:center;}
  .cg{display:grid;grid-template-columns:repeat(7,1fr);gap:3px;}
  .cw{text-align:center;font-size:11px;font-weight:700;color:var(--tx3);padding:5px 0;}
  .cw:first-child{color:var(--re);} .cw:last-child{color:var(--ac);}
  .cal-day{min-height:80px;background:var(--sf2);border:1px solid var(--bd);border-radius:7px;padding:5px;transition:border-color .1s;}
  .cal-day.today{border-color:var(--ac);border-width:2px;}
  .cal-day.om{opacity:.3;}
  .cal-day.sun .cal-dn{color:var(--re);} .cal-day.sat .cal-dn{color:var(--ac);}
  .cal-day.hd{background:rgba(239,68,68,.06);}
  .cal-dn{font-size:12px;font-weight:700;margin-bottom:3px;}
  .cal-hn{font-size:9px;color:#ef4444;font-weight:600;line-height:1.2;margin-bottom:2px;}
  .cal-dot{display:block;font-size:10px;border-radius:3px;padding:1px 4px;margin:1px 0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .cd0{background:rgba(30,58,95,.15);color:var(--ac);} .cd1{background:rgba(220,38,38,.12);color:var(--re);}
  .cd2{background:rgba(124,58,237,.12);color:var(--ac2);} .cd3{background:rgba(217,119,6,.12);color:var(--ye);}
  .cl{display:flex;gap:10px;flex-wrap:wrap;margin-top:12px;}
  .cli{display:flex;align-items:center;gap:5px;font-size:12px;color:var(--tx2);}
  .cld{width:10px;height:10px;border-radius:3px;flex-shrink:0;}
  .pg{display:grid;grid-template-columns:1fr 1fr;gap:20px;align-items:stretch;}
  .pr{display:flex;justify-content:space-between;align-items:center;padding:9px 0;border-bottom:1px solid var(--bd);font-size:14px;}
  .pr:last-child{border-bottom:none;} .pv{font-family:'DM Mono',monospace;font-weight:700;color:var(--ac);}
  .pru{display:flex;gap:8px;padding:7px 0;font-size:13px;color:var(--tx2);border-bottom:1px solid var(--bd);}
  .pru:last-child{border-bottom:none;} .pru::before{content:"•";color:var(--ac);font-weight:700;flex-shrink:0;}
  .rg{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;}
  .rc{background:var(--sf2);border:1px solid var(--bd);border-radius:10px;padding:14px;}
  .rn{font-size:13px;font-weight:700;margin-bottom:10px;display:flex;align-items:center;gap:6px;}
  .rrow{display:flex;justify-content:space-between;align-items:center;font-size:12px;margin-bottom:4px;}
  .rbar{height:5px;background:var(--bd);border-radius:3px;overflow:hidden;margin-bottom:8px;}
  .rbf{height:100%;border-radius:3px;transition:width .4s;}
  @keyframes refreshBar{from{width:0%}to{width:100%}}
`;



// ── 타입 변환 헬퍼 ─────────────────────────────────────────────────
export const TYPE_KR={"연차":"연차","병가":"병가","특이사항":"특이사항"};
export const TYPE_EN={"연차":"Annual Leave","병가":"Sick Leave","특이사항":"Note","Annual Leave":"Annual Leave","Sick Leave":"Sick Leave","Note":"Note"};
export const TYPE_TO_KR={"Annual Leave":"연차","Sick Leave":"병가","Note":"특이사항","연차":"연차","병가":"병가","특이사항":"특이사항","Vacaciones":"연차","Baja por enfermedad":"병가","Nota":"특이사항"};
export const TYPE_ES={"연차":"Vacaciones","병가":"Baja por enfermedad","특이사항":"Nota","Annual Leave":"Vacaciones","Sick Leave":"Baja por enfermedad","Note":"Nota","Vacaciones":"Vacaciones","Baja por enfermedad":"Baja por enfermedad","Nota":"Nota"};
export function dispType(type, lang){ if(lang==="kr"){ return TYPE_TO_KR[type]||type; } if(lang==="es"){ return TYPE_ES[type]||type; } return TYPE_EN[type]||type; }
export function toKrType(type){ return TYPE_TO_KR[type]||type; }
// ────────────────────────────────────────────────────────────────

// ── Firebase Cloud Messaging 설정 ──────────────────────────────
export const firebaseConfig = {
  apiKey: "AIzaSyA-HRVQ3V3lQtKXoYktPMVcCmsJ9SRE7ZE",
  authDomain: "springblinds-hr.firebaseapp.com",
  projectId: "springblinds-hr",
  storageBucket: "springblinds-hr.firebasestorage.app",
  messagingSenderId: "88995904958",
  appId: "1:88995904958:web:0f71ed338980f874914def"
};
export const firebaseApp = initializeApp(firebaseConfig);
export const FCM_VAPID_KEY = "BKDEHKvOPTIXOI38SK1W7V92WU8sLd6aTDbrIpCq7-YXJEfhBtJLh0Txx6e8IK7KV6UuuanQBHQXsRY-wEbFVfI";

// ── Push Notification 유틸 (기존 VAPID, 사용 중단 예정) ──────────
export const VAPID_PUBLIC_KEY = "BBe5YQtIq0XaB0UyDeZ6dcZDxbzkvRvGOJZQ2vA3I3lhQf7tMEJoA2klItfN_46-_--yoL34bQ_OGi2Coc4aJhU";

export function urlBase64ToUint8Array(base64String) {
  const base64 = base64String.replace(/-/g, "+").replace(/_/g, "/");
  const str = atob(base64);
  const buf = new ArrayBuffer(str.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < str.length; i++) {
    view[i] = str.charCodeAt(i);
  }
  return view;
}

// 공통: 토큰 배열을 받아 한 명씩 독립적으로 발송 (한 명 실패해도 나머지는 계속 진행)
async function sendPushToSubs(subs, token, titleKr, bodyKr, titleEn, bodyEn, url, es){
  if (!subs || subs.length === 0) return;
  for(const s of subs) {
    if(!s || !s.fcm_token) continue;
    const isKr = s.lang === "kr";
    const isEs = s.lang === "es" && es && es.title && es.body;
    try {
      await fetch("https://spjouqdizmcpehsspfed.supabase.co/functions/v1/send-push", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ subscriptions: [s], title: isKr ? titleKr : isEs ? es.title : titleEn, body: isKr ? bodyKr : isEs ? es.body : bodyEn, url })
      });
    } catch(inner) { console.log("Push failed for one subscription:", s.fcm_token, inner); }
  }
}

export async function sendPushToAdmin(supabase, titleKr, bodyKr, titleEn, bodyEn, url="/", es=null) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const lsKey = Object.keys(localStorage).find(k => k.includes("auth-token"));
    const lsToken = lsKey ? JSON.parse(localStorage.getItem(lsKey)||"{}").access_token : null;
    const token = session?.access_token || lsToken;
    const adminIds = (await supabase.from("profiles").select("id").eq("role","admin")).data?.map(p=>p.id)||[];
    const { data: subs } = await supabase.from("push_subscriptions").select("fcm_token, lang").in("user_id", adminIds);
    await sendPushToSubs(subs, token, titleKr, bodyKr, titleEn, bodyEn, url, es);
  } catch(e) { console.log("Push failed:", e); }
}

export async function sendPushToEmployee(supabase, empName, titleKr, bodyKr, titleEn, bodyEn, url="/", es=null) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const lsKey = Object.keys(localStorage).find(k => k.includes("auth-token"));
    const lsToken = lsKey ? JSON.parse(localStorage.getItem(lsKey)||"{}").access_token : null;
    const token = session?.access_token || lsToken;
    const { data: profile } = await supabase.from("profiles").select("id").eq("emp_name", empName).single();
    if (!profile) return;
    const { data: subs } = await supabase.from("push_subscriptions").select("fcm_token, lang").eq("user_id", profile.id);
    await sendPushToSubs(subs, token, titleKr, bodyKr, titleEn, bodyEn, url, es);
  } catch(e) { console.log("Push failed:", e); }
}

export async function sendPushToAll(supabase, titleKr, bodyKr, titleEn, bodyEn, url="/", es=null) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const lsKey = Object.keys(localStorage).find(k => k.includes("auth-token"));
    const lsToken = lsKey ? JSON.parse(localStorage.getItem(lsKey)||"{}").access_token : null;
    const token = session?.access_token || lsToken;
    const { data: subs } = await supabase.from("push_subscriptions").select("fcm_token, lang");
    await sendPushToSubs(subs, token, titleKr, bodyKr, titleEn, bodyEn, url, es);
  } catch(e) { console.log("Push failed:", e); }
}
// ────────────────────────────────────────────────────────────────
